import Ajv from "ajv";


const liveUnitsSchema = {
    type: "object",
    required: ["status", "statusMessage", "data"],
    properties: {
        status: { const: 200 },
        statusMessage: { type: "string" },
        data: {
            type: "array",
            items: {
                type: "object",
                required: ["id", "name", "serial", "locationName", "regionName", "clientName", "favoritesListsNames"],
                properties: {
                    clientName: { type: "string" },
                    favoritesListsNames: {
                        type: "array",
                        items: { type: "string" },
                    },
                    id: { type: "integer" },
                    locationName: { type: "string" },
                    name: { type: "string" },
                    regionName: { type: ["string", "null"] },
                    serial: { type: ["string", "null"] },
                },
                additionalProperties: true,
            },
        },
    },
    additionalProperties: false,
};

export const liveUnitsSearchValidator = new Ajv().compile(liveUnitsSchema);
